import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from 'services/auth/hooks';
import { Paths } from 'services/navigation/paths';
import { isSafeInternalPath } from 'services/auth/utils/ssoRedirect';

// Front-channel logout endpoint for SSO partners (e.g. Zenith): hitting /logout
// ends the Popp session (clears local tokens + Cognito GlobalSignOut) and lands
// on /login, whether or not a session is active. An optional safe ?next=
// overrides the default /login destination, mirroring the SSO login deep-link.
export const LogoutPage = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const nextParam = searchParams.get('next');
    const target = isSafeInternalPath(nextParam) ? nextParam : Paths.LOGIN;
    // signOut redirects to `target` on success; redirect ourselves if there is
    // no active session to sign out of so the user still lands cleanly.
    signOut(target).catch(() => {
      navigate(target, { replace: true });
    });
  }, [searchParams, signOut, navigate]);

  return null;
};
